// Shared offer utilities
// Determines if a copilot is eligible to make a new offer:
// true when the copilot has no offers or only rescinded offers on the item.
export function isEligibleToMakeOffer<T extends { copilot: { id: number }, status: string }>(
  offers: T[],
  copilotId: number
): boolean {
  return !offers.some((offer) => offer.copilot.id === copilotId && offer.status !== 'rescinded');
}


